// Generated by purs version 0.13.0
"use strict";
var Ritoppu_Action_CreatureAct = require("../Ritoppu.Action.CreatureAct/index.js");
var increasePower = function (dp) {
    return function (game) {
        return Ritoppu_Action_CreatureAct.creatureAct({
            stage: {
                player: {
                    pos: game.stage.player.pos,
                    stats: {
                        maxHp: game.stage.player.stats.maxHp,
                        hp: game.stage.player.stats.hp,
                        defense: game.stage.player.stats.defense,
                        power: game.stage.player.stats.power + dp | 0
                    },
                    turn: game.stage.player.turn,
                    inventory: game.stage.player.inventory,
                    level: game.stage.player.level,
                    equipment: game.stage.player.equipment
                },
                tiles: game.stage.tiles,
                size: game.stage.size,
                seen: game.stage.seen,
                items: game.stage.items,
                fovMask: game.stage.fovMask,
                creatures: game.stage.creatures
            },
            dungeonLevel: game.dungeonLevel
        });
    };
};
var increaseMaxHp = function (dh) {
    return function (game) {
        return Ritoppu_Action_CreatureAct.creatureAct({
            stage: {
                player: {
                    pos: game.stage.player.pos,
                    stats: {
                        maxHp: game.stage.player.stats.maxHp + dh | 0,
                        hp: game.stage.player.stats.hp + dh | 0,
                        defense: game.stage.player.stats.defense,
                        power: game.stage.player.stats.power
                    },
                    turn: game.stage.player.turn,
                    inventory: game.stage.player.inventory,
                    level: game.stage.player.level,
                    equipment: game.stage.player.equipment
                },
                tiles: game.stage.tiles,
                size: game.stage.size,
                seen: game.stage.seen,
                items: game.stage.items,
                fovMask: game.stage.fovMask,
                creatures: game.stage.creatures
            },
            dungeonLevel: game.dungeonLevel
        });
    };
};
var increaseDefense = function (df) {
    return function (game) {
        return Ritoppu_Action_CreatureAct.creatureAct({
            stage: {
                player: {
                    pos: game.stage.player.pos,
                    stats: {
                        maxHp: game.stage.player.stats.maxHp,
                        hp: game.stage.player.stats.hp,
                        defense: game.stage.player.stats.defense + df | 0,
                        power: game.stage.player.stats.power
                    },
                    turn: game.stage.player.turn,
                    inventory: game.stage.player.inventory,
                    level: game.stage.player.level,
                    equipment: game.stage.player.equipment
                },
                tiles: game.stage.tiles,
                size: game.stage.size,
                seen: game.stage.seen,
                items: game.stage.items,
                fovMask: game.stage.fovMask,
                creatures: game.stage.creatures
            },
            dungeonLevel: game.dungeonLevel
        });
    };
};
module.exports = {
    increaseMaxHp: increaseMaxHp,
    increasePower: increasePower,
    increaseDefense: increaseDefense
};
